import './index.styl';
import Radio from "backbone.radio";
import { Model } from "backbone";
import { PlayerPool, PlayerPoolList } from '../../Fantasy';
import { PlayerComparisonPlayerPoolFilters } from '../PlayerComparisonPlayerPoolFilters';

const playerComparisonChannel = Radio.channel('player:comparison');

export class PlayerComparisonPlayerPool extends PlayerPool {

	initialize() {
		this.model = new Model({
			selected_position: ''
		});

		this.showChildView('pool', new PlayerPoolList());
		this.showChildView('filters', new PlayerComparisonPlayerPoolFilters());

		this.listenTo(playerComparisonChannel, 'show:data', this.init);
		this.listenTo(playerComparisonChannel, 'lock:players', this.lockPlayers);
		this.listenTo(playerComparisonChannel, 'unlock:players', this.unLockPlayers);
		this.listenTo(playerComparisonChannel, 'removed:player', this.onRemovedPlayer);
	}

	init(args){
		super.init(args);

		const
			collection = this.getChildView('pool').collection,
			id = args.selected_player,
			model = collection.get({ id });

		if(model){
			this.onPlayerAdd({ model });
		}
	}

	applyStyleWithCoachBanner() {
		return this;
	}

	get player_pool(){
		return this.getChildView('pool').collection;
	}

	togglePlayersLockState(is_locked){
		this.player_pool.each(player => player.set({ is_locked }, { silent: true }));
		this.player_pool.reset(this.player_pool.toJSON());

		return this;
	}

	lockPlayers(){
		return this.togglePlayersLockState(true);
	}

	unLockPlayers(){
		return this.togglePlayersLockState(false);
	}

	onPlayerAdd({ model }) {
		const player = model.toJSON();

		model.collection.remove(model.id);

		playerComparisonChannel.trigger('player:add', { player });
	}

	onRemovedPlayer({ player }){
		this.player_pool.add(player);
	}
}

export default PlayerComparisonPlayerPool;